import { render, staticRenderFns } from "./edit-order-item.vue?vue&type=template&id=36b72276&"
import script from "./edit-order-item.vue?vue&type=script&lang=js&"
export * from "./edit-order-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports